module.exports = __webpack_public_path__ + "assets/756383a844659b7b769bc1824b45eedb.mp3";